for (const playerAllowedItemsForm of document.querySelectorAll(
    '.player-allowed-items'
)) {
    for (const checkbox of playerAllowedItemsForm.querySelectorAll(
        'input[type="checkbox"]'
    )) {
        checkbox.addEventListener('change', function () {
            updateAllowedItemsCounterAndButtons(playerAllowedItemsForm);
        });
    }
    for (const selectAllButton of playerAllowedItemsForm.querySelectorAll(
        '.allowed-items-select-all'
    )) {
        selectAllButton.addEventListener('click', function () {
            const productWrapper = selectAllButton.closest(
                '.player-allowed-items-product'
            );
            for (const checkbox of productWrapper.querySelectorAll(
                'input[type="checkbox"]'
            )) {
                checkbox.checked = false;
            }
            selectAllButton
                .closest('.tab-pane')
                .querySelector('.disable-product input').checked = false;
            updateAllowedItemsCounterAndButtons(playerAllowedItemsForm);
        });
    }
    for (const disableProductCheckbox of playerAllowedItemsForm.querySelectorAll(
        '.disable-product input'
    )) {
        disableProductCheckbox.addEventListener('change', function () {
            for (const checkbox of disableProductCheckbox
                .closest('.tab-pane')
                .querySelectorAll(
                    '.player-allowed-items-product input[type="checkbox"]'
                )) {
                if (disableProductCheckbox.checked) {
                    checkbox.checked = false;
                }
                checkbox.disabled = disableProductCheckbox.checked;
            }
        });
    }

    for (const sectionSelectBox of playerAllowedItemsForm.querySelectorAll(
        'select[name="section_key"]'
    )) {
        const container = sectionSelectBox.closest('.tab-pane');
        sectionSelectBox.addEventListener('change', function () {
            switchSection(container, sectionSelectBox.value);
        });
        switchSection(container, sectionSelectBox.value);
    }
}

function switchSection(productContainer, section_key) {
    for (const section of productContainer.querySelectorAll(
        '[data-allowed-items-section-key]'
    )) {
        if (!section.dataset.allowedItemsSectionKey) {
            continue;
        }
        if (section.dataset.allowedItemsSectionKey === section_key) {
            section.classList.remove('d-none');
            continue;
        }
        section.classList.add('d-none');
    }
}

function updateAllowedItemsCounterAndButtons(playerAllowedItemsForm) {
    for (const counter of playerAllowedItemsForm.querySelectorAll(
        '.allowed-items-count'
    )) {
        const allowedItemsPerProductCount = counter
            .closest('.player-allowed-items-product')
            .querySelectorAll('input[type="checkbox"]:checked').length;
        const allowAllItemsButton = counter
            .closest('.player-allowed-items-product')
            .querySelector('.player-allow-all-items-button');
        const product_disabled = counter
            .closest('.tab-pane')
            .querySelector('.disable-product input').checked;
        if (product_disabled) {
            counter.innerText = 'Keine Themen erlaubt';
            allowAllItemsButton.classList.add('d-none');
            continue;
        }
        if (allowedItemsPerProductCount) {
            allowAllItemsButton.classList.remove('d-none');
        } else {
            allowAllItemsButton.classList.add('d-none');
        }
        if (!allowedItemsPerProductCount) {
            counter.innerText = 'Alle Themen erlaubt';
            continue;
        }
        if (allowedItemsPerProductCount === 1) {
            counter.innerText = '1 Thema erlaubt';
            continue;
        }
        counter.innerText = allowedItemsPerProductCount + ' Themen erlaubt';
    }
}
